{
  "shared": {
    "none": "(none)",
    "notSet": "Not set",
    "reason": "Reason",
    "reasonRequired": "Reason (required)"
  },
  "policyModes": {
    "block": "Block",
    "warn": "Warn",
    "off": "Off"
  },
  "confirmChange": {
    "heading": "Change {{label}}",
    "body": "Change from <strong>{{from}}</strong> to <strong>{{to}}</strong>. The change is logged with your name."
  },
  "settings": {
    "saved": "Saved",
    "loadFailed": "The drill and blast settings could not be loaded.",
    "thisMine": "This mine",
    "systemOfRecord": "System of record",
    "setAtDeployment": "Set at deployment",
    "regulatoryProfile": "Regulatory profile",
    "startingValuesOnly": "Starting values only",
    "modules": "Modules",
    "noModules": "None",
    "policyRules": "Policy rules",
    "integrityNote": "Integrity rules always apply and are not listed: balances never go negative, register entries are never deleted, and hole status is worked out from the records. Records imported from another system are checked against these rules and reported, never refused.",
    "mandatoryFields": "Mandatory fields",
    "unitsTolerances": "Units, tolerances and windows"
  },
  "policies": {
    "record": "Record",
    "area": "Area",
    "field": "Field",
    "rule": "Rule",
    "profileDefault": "Profile default"
  },
  "history": {
    "title": "Change history",
    "when": "When",
    "who": "Who",
    "setting": "Setting",
    "change": "Change"
  },
  "bulkClose": {
    "title": "Close old patterns",
    "description": "Closes patterns still showing as drilling, drilled, charging, charged or fired with no blast, drilling or digging since the date chosen. Designs nobody has worked on and patterns with an open misfire are left alone. The closure is recorded in the change history with its reason.",
    "nothingSince": "Nothing since",
    "preview": "Preview",
    "previewFailed": "The preview could not be loaded",
    "wouldClose_one": "<strong>{{count}}</strong> pattern would close.",
    "wouldClose_other": "<strong>{{count}}</strong> patterns would close.",
    "wouldCloseByStatus_one": "<strong>{{count}}</strong> pattern would close ({{breakdown}}).",
    "wouldCloseByStatus_other": "<strong>{{count}}</strong> patterns would close ({{breakdown}}).",
    "forExample": "For example {{patterns}}.",
    "closeCount_one": "Close {{count}} pattern",
    "closeCount_other": "Close {{count}} patterns",
    "confirmBody": "Every pattern listed will be marked closed and completed. Any one of them can be reopened from its pattern page.",
    "closePatterns": "Close patterns",
    "closed_one": "Closed {{count}} pattern",
    "closed_other": "Closed {{count}} patterns"
  },
  "surveyGrid": {
    "title": "Survey grid",
    "addPoint": "Add a control point",
    "pointHeading": "Control point {{name}}",
    "useInFit": "Use in the fit",
    "gridEasting": "Grid easting (m)",
    "gridNorthing": "Grid northing (m)",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "gridE": "Grid E",
    "gridN": "Grid N",
    "residual": "Residual",
    "notUsed": "Not used",
    "remove": "Remove",
    "grid": "Grid",
    "setAbove": "Set above, by a Lead Admin",
    "convertsAs": "Converts as",
    "nothingYet": "Nothing yet",
    "fittedScale": "Fitted scale",
    "fittedRotation": "Fitted rotation",
    "help": "For a local mine grid, set the grid to Local and enter three or more points surveyed in both the grid and GPS. Eclipse fits a shift, rotation and scale to them; a point well off the fit, shown in red, is usually a mistyped coordinate. Hole positions are kept as delivered and only their map position is worked out from this."
  },
  "personnel": {
    "employeeNo": "Employee no.",
    "employer": "Employer",
    "nameRequired": "A name is required",
    "added": "Person added",
    "saved": "Person saved"
  },
  "licences": {
    "licence": "Licence",
    "number": "Number",
    "issuedBy": "Issued by",
    "issuedOn": "Issued on",
    "expiresOn": "Expires on",
    "numberRequired": "A licence number is required",
    "added": "Licence added",
    "saved": "Licence saved",
    "removed": "Licence removed"
  }
}
